import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { DeliveryLocations } from "../../financial.types";
import { requestDeliveryLocations } from "./deliveryLocations.request";

const useDeliveryLocations = (
  options?: QueryOptions<DeliveryLocations, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["delivery-locations"],
    queryFn: requestDeliveryLocations,
    ...options
  });

  return { deliveryLocations: data, ...rest };
};

export default useDeliveryLocations;
